import script from "./UserManualHours.vue?vue&type=script&setup=true&lang=js"
export * from "./UserManualHours.vue?vue&type=script&setup=true&lang=js"

import "./UserManualHours.vue?vue&type=style&index=0&id=47b4566e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47b4566e"]])

export default __exports__